module.exports = __webpack_public_path__ + "static/retail-content-image-1_new@2x-7eaf5ea999596b2048deeeb894428042.jpg";